//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import GBranchOfficeListView from "@/views/General/GBranchOffice/GBranchOfficeList"
import GBranchOfficeCreateView from "@/views/General/GBranchOffice/GBranchOfficeCreate"
import GBranchOfficeUpdateView from "@/views/General/GBranchOffice/GBranchOfficeUpdate"

//
export default {
  path: "branch_offices",
  component: ModuleLayout,
  children: [
    {
      name: "g-branch-office-list",
      path: "",
      component: GBranchOfficeListView,
    },
    {
      name: "g-branch-office-create",
      path: "create",
      component: GBranchOfficeCreateView,
      meta: {
        title: "Crear sucursal"
      },
    },
    {
      name: "g-branch-office-update",
      path: ":id",
      component: GBranchOfficeUpdateView,
      meta: {
        title: "Detalle de sucursal"
      },
    },
  ],
  meta: {
    title: "Sucursales"
  },
}